import { Driver } from '../types/fleet'

export const drivers: Driver[] = [
  {
    id: 'd1',
    name: 'Довлет Аманов',
    status: 'free',
    car: 'Toyota Corolla, белый',
    plate: 'AG 4720 MK',
    location: 'проспект Махтумкули, 18',
    phone: '+993 65 41-18-08',
    rating: 4.9,
    tripsToday: 12,
    earningsToday: 412,
    x: 27,
    y: 32,
    distanceKm: 1.2,
    etaMin: 4,
  },
  {
    id: 'd2',
    name: 'Айна Реджепова',
    status: 'busy',
    car: 'Hyundai Elantra, серый',
    plate: 'AG 1180 TS',
    location: 'улица Битарап Туркменистан, 45',
    phone: '+993 62 77-45-22',
    rating: 4.8,
    tripsToday: 9,
    earningsToday: 318,
    x: 58,
    y: 55,
    distanceKm: 3.8,
    etaMin: 11,
  },
  {
    id: 'd3',
    name: 'Бегенч Оразов',
    status: 'free',
    car: 'Kia Cerato, синий',
    plate: 'AG 9030 RN',
    location: 'улица Гёроглы, 24',
    phone: '+993 63 34-07-91',
    rating: 4.7,
    tripsToday: 7,
    earningsToday: 246,
    x: 42,
    y: 24,
    distanceKm: 2.1,
    etaMin: 6,
  },
  {
    id: 'd4',
    name: 'Керим Худайбердыев',
    status: 'offline',
    car: 'Toyota Camry, чёрный',
    plate: 'AG 5560 OR',
    location: 'проспект Арчабиль, 12',
    phone: '+993 61 11-80-47',
    rating: 4.6,
    tripsToday: 4,
    earningsToday: 132,
    x: 17,
    y: 66,
    distanceKm: 7.4,
    etaMin: 22,
  },
  {
    id: 'd5',
    name: 'Максат Нурыев',
    status: 'busy',
    car: 'Toyota Camry, белый',
    plate: 'AG 2100 AW',
    location: 'проспект Огузхан, 8',
    phone: '+993 65 65-49-30',
    rating: 5.0,
    tripsToday: 15,
    earningsToday: 574,
    x: 71,
    y: 30,
    distanceKm: 4.5,
    etaMin: 13,
  },
  {
    id: 'd6',
    name: 'Сельби Атаева',
    status: 'free',
    car: 'Hyundai Accent, белый',
    plate: 'AG 7450 ET',
    location: 'улица Атамурата Ниязова, 61',
    phone: '+993 62 22-05-14',
    rating: 4.9,
    tripsToday: 11,
    earningsToday: 386,
    x: 63,
    y: 74,
    distanceKm: 2.9,
    etaMin: 8,
  },
  {
    id: 'd7',
    name: 'Батыр Гельдиев',
    status: 'busy',
    car: 'Lexus ES, серебристый',
    plate: 'AG 3310 UK',
    location: 'шоссе Берзеньги, 34',
    phone: '+993 64 44-71-06',
    rating: 4.5,
    tripsToday: 8,
    earningsToday: 274,
    x: 36,
    y: 80,
    distanceKm: 6.2,
    etaMin: 18,
  },
  {
    id: 'd8',
    name: 'Гурбан Сапаров',
    status: 'offline',
    car: 'Nissan Sunny, серый',
    plate: 'AH 6820 SM',
    location: 'улица Андалып, 5',
    phone: '+993 63 80-92-73',
    rating: 4.4,
    tripsToday: 3,
    earningsToday: 98,
    x: 82,
    y: 58,
    distanceKm: 9.1,
    etaMin: 27,
  },
  {
    id: 'd9',
    name: 'Мердан Ходжаев',
    status: 'free',
    car: 'Toyota Corolla, серебристый',
    plate: 'AG 1940 NA',
    location: 'площадь Гарашсызлык, 3',
    phone: '+993 65 51-26-88',
    rating: 4.8,
    tripsToday: 10,
    earningsToday: 344,
    x: 50,
    y: 44,
    distanceKm: 1.8,
    etaMin: 5,
  },
]
